import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode } from "vue"

import type { TreeProps } from 'ant-design-vue'
import { ref, computed } from 'vue'
import type { PropType } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'tree',
  props: {
  treeData: {
    type: Array as PropType<TreeProps['treeData']>,
    default: () => []
  },
  dataSource: {
    type: Array,
    default: () => []
  },
  searchData: {
    type: Object,
    default: () => {
      return {}
    }
  },
  checkable: {
    type: Boolean,
    default: true
  }
  // checkedKeys: {
  //   type: Array,
  //   default: () => []
  // }
},
  setup(__props) {

const props = __props
// 拿到 props.checkedKeys 分割成数组
// watch(
//   props.checkedKeys,
//   () => {
//     console.log(2222)
//   },
//   {
//     deep: true,
//     immediate: true
//   }
// )
const selectedKeys = ref<string[]>([])
const checkedKeys = ref<string[]>([])
const selectedParentKeys = ref<string[]>([])
// 处理treeData 生成多个tree （仅为了做UI样式）
const treeDataComputed = computed(() => {
  const result: any = []
  props.treeData &&
    props.treeData.forEach((item) => {
      result.push([item])
    })
  return result
})
// 列选中
const onSelect = (selectedKey: [], e: { selected: boolean; selectedNodes: any; node: any; event: any }) => {
  let keys: string[] = []
  if (!selectedKey || !selectedKey.length) {
    selectedParentKeys.value = []
    return
  }
  if (e?.node?.parent?.nodes) {
    e.node.parent.nodes.forEach((item: any) => {
      keys.push(item.key)
    })
  } else {
    keys = selectedKey
  }
  selectedParentKeys.value = keys
}
// 复选框选中
const onCheck = (checkedKey: any, e: { checked: boolean; checkedNodes: any; node: any; event: any }) => {
  // 整合checkedKeys
  console.log(checkedKey, e)
}

return (_ctx: any,_cache: any) => {
  const _component_a_tree = _resolveComponent("a-tree")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(treeDataComputed.value, (item, index) => {
    return (_openBlock(), _createElementBlock("div", {
      class: _normalizeClass([
      selectedParentKeys.value && selectedParentKeys.value[0] && selectedParentKeys.value[0] === item[0].key ? 'check-tree' : 'init-tree',
      'tree-content',
      __props.checkable ? 'multiple-table' : 'single-tree'
    ]),
      key: index
    }, [
      _createVNode(_component_a_tree, _mergeProps(_ctx.$attrs, {
        selectedKeys: selectedKeys.value,
        "onUpdate:selectedKeys": _cache[0] || (_cache[0] = ($event: any) => ((selectedKeys).value = $event)),
        checkedKeys: checkedKeys.value[index],
        "onUpdate:checkedKeys": ($event: any) => ((checkedKeys.value[index]) = $event),
        showIcon: false,
        checkable: __props.checkable,
        "tree-data": item,
        onSelect: onSelect,
        onCheck: onCheck,
        autoExpandParent: true
      }), {
        title: _withCtx(({ dataRef }) => [
          _createElementVNode("div", {
            class: _normalizeClass([dataRef.class, dataRef.children && dataRef.children.length ? 'has-tree-child' : 'no-tree-child'])
          }, [
            _renderSlot(_ctx.$slots, "title", {}, () => [
              _createTextVNode(_toDisplayString(dataRef.title), 1)
            ])
          ], 2)
        ]),
        _: 2
      }, 1040, ["selectedKeys", "checkedKeys", "onUpdate:checkedKeys", "checkable", "tree-data"])
    ], 2))
  }), 128))
}
}

})